import Carousel from "@component/carousel/Carousel";
import LazyImage from "@component/LazyImage";
import React from "react";
import Container from "../Container";
import useNextBlurhash from "use-next-blurhash";
import Link from "next/link";

const SectionSlider = ({ sliders, setting }) => {
  const title = setting?.filter(
    (prop) => prop.attributes.Name === "site.title"
  )[0];

  return (
    <Container pb="1rem">
      <Carousel
        visibleSlides={1}
        infinite={true}
        autoPlay={true}
        showDots={false}
        spacing={0}
      >
        {sliders.map((slider, index) => {
          return (
            <Link href={slider.attributes.Link} key={index}>
              <LazyImage
                loader={() =>
                  slider.attributes.Media.data.attributes.formats.thumbnail.url
                }
                src={slider.attributes.Media.data.attributes.url}
                blurDataURL={
                  useNextBlurhash(
                    slider.attributes.Media.data.attributes.blurhash
                  )[0]
                }
                width={1200}
                height={700}
                placeholder="blur"
                alt={`${title?.attributes.Value} ${slider.attributes.Media.data.attributes.name}`}
              />
            </Link>
          );
        })}
      </Carousel>
    </Container>
  );
};

export default SectionSlider;
